module.exports = __webpack_public_path__ + "media/images/app/homepage/wot3-f05cc499c289af0930e42d820b23be8e.webp";